import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api, fileUrl, apiError } from "@/lib/api";
import { toast } from "sonner";

export function ImageUploader({ value, onChange, label = "Immagine", testId = "image-uploader", compact = false }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const pick = () => inputRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Immagine caricata");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      {!compact && <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-zinc-500">{label}</p>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={fileUrl(value)} alt="" className={`rounded-xl object-cover ${compact ? "h-12 w-12" : "h-20 w-20"}`} />
            <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange(null)}
              className="absolute -right-2 -top-2 rounded-full bg-red-500 p-1 text-white">
              <X className="h-3 w-3" />
            </button>
          </div>
        ) : (
          <button type="button" data-testid={testId} onClick={pick} disabled={uploading}
            className={`flex items-center justify-center gap-2 rounded-xl border-2 border-dashed border-slate-300 text-zinc-400 transition-colors hover:border-green-500 hover:text-green-600 ${compact ? "h-12 w-12" : "h-20 w-20"}`}>
            {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          </button>
        )}
        {value && (
          <button type="button" onClick={pick} className="text-xs font-bold text-green-600 hover:underline">Cambia</button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" hidden onChange={handleFile} />
    </div>
  );
}
